export default "__VITE_ASSET__CPQoyOW$__"